import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.infra.project.monitor');
import { OnInit, OnDestroy, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-infra-project-monitor',
template: templateSource || '',
    styles: [`

/* file: /opt/season-cloud-manager/project/main/build/src/app/portal.infra.project.monitor/view.scss */
/* src/app/portal.infra.project.monitor/view.scss: no such file or directory */`],
})
export class PortalInfraProjectMonitorComponent implements OnInit, OnDestroy {
    @Input() project: any;
    @Input() role: any = 'member';

    public intervalId: any;

    public data: any = {};

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        this.intervalId = setInterval(async () => {
            await this.load();
        }, 5000);
    }

    public async ngOnDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }

    public async load() {
        const { code, data } = await wiz.call("load", { id: this.project.id });
        this.data = data;
        await this.service.render();
    }

    public timeDifferenceFormat(targetDate: any) {
        if (!targetDate) return '-';
        if (typeof targetDate === 'string') {
            if (!targetDate.includes("Z") && !/[+-]\d{2}:\d{2}$/.test(targetDate)) {
                targetDate = new Date(targetDate + '+09:00');
            } else {
                targetDate = new Date(targetDate);
            }
        }
        const now: any = new Date();
        const diffInSeconds = Math.floor((now - targetDate) / 1000);

        const seconds = diffInSeconds % 60;
        const minutes = Math.floor((diffInSeconds / 60) % 60);
        const hours = Math.floor((diffInSeconds / 3600) % 24);
        const days = Math.floor((diffInSeconds / (3600 * 24)) % 365);
        const years = Math.floor(diffInSeconds / (3600 * 24 * 365));

        let result = [];

        if (years > 0) result.push(`${years}y`);
        if (days > 0) result.push(`${days}d`);
        if (hours > 0) result.push(`${hours}h`);
        if (minutes > 0) result.push(`${minutes}m`);
        if (seconds > 0) result.push(`${seconds}s`);

        return result.slice(0, 2).join(' ') || '0s';
    }

    public formatPorts(ports: any[]) {
        if (!ports || ports.length === 0) return '-';
        return ports.map(p => `${p.port}:${p.target_port}/${p.protocol}`).join(', ');
    }

    public formatExternalIPs(ips: any[]) {
        if (!ips || ips.length === 0) return '<none>';
        return ips.join(', ');
    }

    public formatAccessModes(modes: any[]) {
        if (!modes || modes.length === 0) return '-';
        return modes.join(', ');
    }

    public formatSelector(selector: any) {
        if (!selector) return '-';
        if (typeof selector === 'string') return selector;
        if (typeof selector === 'object') {
            return Object.entries(selector).map(([k, v]) => `${k}=${v}`).join(', ');
        }
        return '-';
    }

    public formatGatewayServer(srv: any) {
        if (!srv) return '-';
        const hosts = srv.hosts ? srv.hosts.join(', ') : '*';
        const port = srv.port ? `${srv.port.number || ''}/${srv.port.protocol || ''}` : '';
        return port ? `${hosts} (${port})` : hosts;
    }

    public statusBadgeClass(status: string) {
        if (!status) return 'bg-gray-100 text-gray-800';
        const s = status.toLowerCase();
        if (s === 'running' || s === 'bound' || s === 'available' || s === 'active') return 'bg-green-100 text-green-800';
        if (s === 'pending' || s === 'released') return 'bg-yellow-100 text-yellow-800';
        if (s === 'failed' || s === 'crashloopbackoff') return 'bg-red-100 text-red-800';
        return 'bg-gray-100 text-gray-800';
    }

    public replicaBadgeClass(ready: number, total: number) {
        if (ready === total && total > 0) return 'bg-green-100 text-green-800';
        if (ready === 0 && total > 0) return 'bg-red-100 text-red-800';
        if (ready < total) return 'bg-yellow-100 text-yellow-800';
        return 'bg-gray-100 text-gray-800';
    }

    public certReadyBadgeClass(ready: any) {
        if (ready === true || ready === 'True' || ready === 'true') return 'bg-green-100 text-green-800';
        if (ready === false || ready === 'False' || ready === 'false') return 'bg-red-100 text-red-800';
        return 'bg-gray-100 text-gray-800';
    }

}

export default PortalInfraProjectMonitorComponent;